import {
  CARE_SERVICE_ORGANS_PARENT_KEY,
  CARE_SERVICE_ORGANS_SUB_KEY,
  CareServiceReportOrgan,
  CareServiceReportOrgansStructure,
} from '@/api';

export interface ReportOrganItem extends CareServiceReportOrgan {
  disabled?: boolean;
}

export interface ReportOrgan extends Omit<CareServiceReportOrgansStructure, 'structure'> {
  structure: ReportOrganItem[];
}

export type ReportLinkProgress = 'Completed' | 'Error' | 'InProgress' | 'missingInput' | 'oncorad';

export const REPORT_LINK_KEY = {
  AI_FINDINGS: 'ai_findings',
  FINAL_IMPRESSIONS: 'final_impressions',
  KEY_IMAGES: 'key_images',
  PREVIEW: 'preview',
  QUALITY_REVIEW: 'quality_review',
  REASON_FOR_SCAN: 'reason_for_scan',
  ...CARE_SERVICE_ORGANS_PARENT_KEY,
  ...CARE_SERVICE_ORGANS_SUB_KEY,
} as const;

export type ReportLinkKey = (typeof REPORT_LINK_KEY)[keyof typeof REPORT_LINK_KEY];

export interface ReportLink {
  disabled?: boolean;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | string;
  key: ReportLinkKey;
  progress: null | ReportLinkProgress;
  sub?: ReportLink[];
  title: string;
}

export interface ReportOrganSummary extends Omit<ReportOrgan, 'structure'> {
  links: ReportLink[];
}
